// extracted by mini-css-extract-plugin
export default {"icon":"taskReportButton_icon__oDQt+","loader":"taskReportButton_loader__cCim6"};